import _ from "lodash"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"

// private module logic //

type LoadingStreamState = {
  loading: boolean
}

const initialState: LoadingStreamState = { loading: false }
const loadingStream = new BehaviorSubject<LoadingStreamState>(initialState)
const active = {}

function toggleLoading(loading: boolean, id: string):void {
  if (loading)  active[id] = true
  else          delete active[id]

  loadingStream.next({ loading: Object.keys(active).length > 0 })
}

// public module interface //

const loadingService = {
  stream: () => loadingStream.asObservable(),
  value: () => loadingStream.getValue().loading,
  toggleLoading
}

export default loadingService
